module.exports = __webpack_public_path__ + "media/images/twitter-962b6d25.png";